import { getLink } from '../../../utils/utils';

import author from './author';
const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Sur nia abieto<br/>
        En granda ora nuks‘<br/>
        Sidadis en kvieto<br/>
        La gnomo sen haluks‘.
      </p>

      <p class="poem-block mb-3">
        Li iam kruron ŝovis<br/>
        En fendon inter ŝel‘;<br/>
        Subite vent‘ ekblovis,<br/>
        La nukson rude movis –<br/>
        Fatalis la ŝancel‘!
      </p>

      <p class="poem-block mb-3">
        De tiam nia gnomo<br/>
        El sia bela domo<br/>
        Ne iras por promen‘:<br/>
        Li sidas kaj kantadas,<br/>
        Fabelojn rakontadas<br/>
        Al pigo kaj ermen‘.
      </p>

      <p class="poem-block mb-3">
        El tiuj ĉi fabeloj<br/>
        Jen estas la plej belaj:
      </p>

      <p class="mb-3 mt-3 text-center"><i>Abieto</i></p>

      <p class="poem-block mb-3">
        En la val‘ abio staris,<br/>
        Olda estis ĝi kaj knaris…<br/>
        Kun hakilo venis hom‘…<br/>
        Jen abio en la dom<br/>
        Lumas ornamita, ĝoja<br/>
        Por Anton‘ kaj lia Zoja.
      </p>

      <p class="mb-3 text-center bold">* * *</p>
      
      <p class="poem-block mb-3">
        Mornas ŝtormo per murmur’:<br/>
        Mor-mor-mor, mur-mur-mur.
      </p>

      <p class="poem-block mb-3">
        Nun nin savos nur la kur’;<br/>
        Mor-mor-mor, mur-mur-mur.
      </p>

      <p class="poem-block mb-3">
        Ondoj glitas laŭ la spur’<br/>
        Kvazaŭ katoj en la kur’,<br/>
        Persekutas en konkur’<br/>
        Nin per langoj el velur’…
      </p>

      <p class="poem-block mb-3">
        Malsekiĝos ni ĝisoste<br/>
        Kaj revenos hejmen poste.<br/>
        Panjo diros: “En futur’<br/>
        Vi al maro – ne mur-mur!”
      </p>
      
    </div>
    `
  )
}

const itemName = {
  esp: 'Infanaj poemetoj'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp:{
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;